export default [
  {
    type: 'STRING',
    name: 'firstName',
    defaultName: 'First Name',
  },
  {
    type: 'STRING',
    name: 'middleName',
    defaultName: 'Middle Name',
  },
  {
    type: 'STRING',
    name: 'lastName',
    defaultName: 'Last Name',
  },
  {
    type: 'STRING',
    name: 'contactEmail',
    defaultName: 'Contact Email',
  },
  {
    type: 'STRING',
    name: 'phoneNumber',
    defaultName: 'Phone Number',
  },
  {
    type: 'STRING',
    name: 'address',
    defaultName: 'Address ',
  },
  {
    type: 'INT',
    name: 'employeeNumber',
    defaultName: 'Employee Number',
  },
  {
    type: 'STRING',
    name: 'profile',
    defaultName: 'Profile',
  },
  {
    type: 'STRING',
    name: 'owner',
    defaultName: 'Owner',
  },
  {
    type: 'STRING',
    name: 'id',
    defaultName: 'Id',
  },
  {
    type: 'DATETIME',
    name: 'created',
    defaultName: 'Created',
  },
  {
    type: 'DATETIME',
    name: 'updated',
    defaultName: 'Updated',
  },
  {
    type: 'BOOLEAN',
    name: 'deleted',
    defaultName: 'Deleted',
  },
  {
    type: 'INT',
    name: 'version',
    defaultName: 'Version',
  },
  {
    type: 'STRING',
    name: 'roles',
    defaultName: 'Roles',
  },
  {
    type: 'BOOLEAN',
    name: 'invited',
    defaultName: 'Invited',
  },
]
